export const GIRL_SCOUTS_USA_ORGANIZERS: string[] = [
  '14421081852', //irl Scouts Louisiana East
  '8422114990', //irl Scouts of Utah
  '15183259005',
  '7856008793', //irl Scouts of the USA-National Meetings
  '7871786469', //irl Scouts of the USA
  '8107240188',
  '8409076354',
  '8513522394', //SUSA Governance Team
  '9086263714',
  '9236384253', //SUSA Property and Program Support to Councils Team
  '9257114355', //SUSA Property and Program Support to Councils Team
  '10041330710',
  '11810291358', //wesome Girls - Girl Scouts of the USA
  '12158914758', //lobal Girl Scouting
  '12951992713', //.I.R.L. 2017 - GSUSA National Event Experiences
  '14233434451',
  '14875441259', //SA Girl Scouts Overseas
  '15867990809', //irl Scouts of the USA - Girl Scout Central
  '16386179918',
  '17055329404', //ychqshop@girlscouts.org
  '17415892803', //ouncil Operations
  '17810150422', //irl Scouts of the USA - Girl Experience
  '18059999206', //SM- Girl Scout Merchandise Sales Events
  '18815589572', //irl Scouts of the USA Volunteerism and Service Delivery Team
  '21663835701', //irl Scouts of the USA - Enterprise Data & Reporting
  '21665897030', //irl Scouts of the USA - Girl Scout Network
  '22775501267', //irl Scouts of the USA
  '7987174571', //uliette Gordon Low Birthplace
  '8235621611', //rices below reflect 50% deposits; balance due upon arrival.  See ticket descriptions for total cost
  '8266970528', //uliette Gordon Low Birthplace
  '12809904006',
  '8842329041', //irl Scouts River Valleys
  '17225390557', //irl Scouts of MN and WI River Valleys
  '34268940075', //irl Scouts River Valleys | Join Girl Scouts
  '10918409584', //irl Scouts Western Pennsylvania
  '30289033388', //irl Scouts of Hawai'i
  '27415461209',
  '27415485377', //irl Scouts of Southern Arizona
  '29696821723',
  '29696851933', //irl Scouts of Silver Sage - Official Page
  '30027475208', ///A
  '30027644384', //irl Scouts of Central and Southern NJ
  '30293683714',
  '30293798512', //irl Scouts Hornets Nest
  '30302680252',
  '30302718518', //iscover Girl Scouts San Diego
  '30347501822',
  '30536451274', //ommunity Area (i.e. West Side or San Fernando Valley)
  '30576485566', //irl Scouts of Greater Los Angeles
  '30368560206', //irl Scouts of Ohio's Heartland - Membership
  '30409788800', //arComm
  '30533222832',
  '30533255056', //irl Scouts of Greater Atlanta
  '30623895126',
  '30623931378', //irl Scout Nation's Capital Programs
  '30683008040',
  '30683018110', //SA Girl Scouts Overseas
  '30852982591',
  '30869706847', //irl Scouts of Northern Indiana-Michiana
  '30924362779',
  '30924648767', //irl Scouts of Northeastern New York
  '31129482637', //irl Scouts of the USA
  '32007878667', //irl Scouts of Central Texas
  '32008080067',
  '32050098149', //irl Scouts of Eastern Massachusetts
  '32053576327', //iscover Girl Scouts of Eastern Massachusetts
  '69392731513',
  '32267507435',
  '32355652159', //irl Scouts of Virginia Skyline
  '69392650953',
  '33778956029',
  '33778968113', //irl Scouts of San Diego
  '69294377823',
  '59040872213', //irl Scouts of West Central Florida
  '67698302963',
  '67698262683',
  '68208952663', //irl Scouts in the Heart of Pennsylvania
  '73015816813', //irl Scouts of North East Ohio
  '74611972233', //irl Scouts of Southeast Florida
  '76974484863',
  '76975330743', //irl Scouts of Eastern Washington & Northern Idaho
  '83781925703',
  '83782207663',
  '83782268083', //irl Scouts Dakota Horizons
  '83782157313', //irl Scouts of Central Indiana
  '93687935753',
] as const;
